import styled from 'styled-components';
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 2;
  position: absolute;
  align-items: center;
  background: #fff;
  height: 100%;
  padding: 0 16px;
  width: 100%;
  flex-wrap: wrap;
  padding-bottom: ${props => props.pb};
`;
export const Text = styled.div`
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.15px;
  margin-top: 16px;
  text-align: center;
  color: ${props => props.color};
  white-space: nowrap;
`;
export const TopOffset = styled.div`
  height: 35%;
`;